import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-326d3619"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "normal-item-span" }
const _hoisted_2 = { class: "prize-item-span" }
const _hoisted_3 = { key: 0 }

import {
  ref,
  onBeforeUnmount,
  onMounted,
  nextTick,
  watch
} from 'vue'
import { defineEmits } from 'vue/dist/vue'

interface Prize {
  id: number
  deptName: string
  empName: string
  amount: number
  raffleType: number
}

// 定义 props 接收外部传入的中奖记录数据

export default /*#__PURE__*/_defineComponent({
  __name: 'SeamlessScroll',
  props: {
    options: {}
  },
  emits: ["refresh"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props

const list = ref<HTMLElement | null>(null)
const visibleItems = ref<Prize[]>(props.options.prizes)
const items = ref<Prize[]>(props.options.items)
const animateClass = ref('animate__fadeInDown')

const emit = __emit

let scrollInterval: number | null = null

watch(
  () => props.options,
  (newValue) => {
    visibleItems.value = newValue.prizes
    items.value = newValue.items
  }
)

function startScrolling() {
  if (scrollInterval) return // 避免重复启动定时器
  scrollInterval = setInterval(() => {
    emit('refresh')
    if (list.value) {
      const itemList = list.value.querySelectorAll('.prize-item')
      if (items.value.length + itemList.length > 7 && itemList.length > 0) {
        const lastItem = itemList[itemList.length - 1]
        const height = lastItem.offsetHeight
        const currentHeight = list.value.scrollTop
        const maxScrollHeight =
          list.value.scrollHeight - list.value.clientHeight
        if (currentHeight + height >= maxScrollHeight) {
          // 当最后一个元素触底时，将其移到最前面
          list.value.insertBefore(lastItem, list.value.firstChild)
          itemList.forEach((item) => {
            list.value.replaceChild(item, item)
          })
          list.value.scrollTop = 0 // 重置滚动位置
        } else {
          list.value.scrollTop += height // 向下滚动一个元素的高度
        }
      }
    }
  }, 5000) // 每3秒滚动一条
}

const renderTemplate = (item: Prize) => {
  let template = ''
  if (item.raffleType === 0) {
    template = `${item.deptName}${item.empName}抽中了手气红包${item.amount}元`
  } else {
    template = `${item.deptName}${item.empName}抽中了惊喜红包${item.amount}元`
  }
  console.log(template)
  return template
}

function stopScrolling() {
  if (scrollInterval) {
    clearInterval(scrollInterval)
    scrollInterval = null
  }
}

onMounted(async () => {
  await nextTick() // 确保DOM已经渲染完成
  startScrolling()
})

onBeforeUnmount(stopScrolling)

// 清理定时器
__expose({ stopScrolling })

return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_empty = _resolveComponent("el-empty")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "normal-item"
        }, [
          _createVNode(_component_el_image, {
            style: {"width":"18px","height":"18px","margin-right":"10px"},
            src: require('@/assets/images/voice.png')
          }, null, 8, ["src"]),
          _createElementVNode("span", _hoisted_1, _toDisplayString(renderTemplate(item)), 1)
        ]))
      }), 128)),
      _createElementVNode("div", {
        class: "prize-list",
        ref_key: "list",
        ref: list
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleItems.value, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: _normalizeClass(['prize-item animate__animated', animateClass.value])
          }, [
            _createVNode(_component_el_image, {
              style: {"width":"18px","height":"18px","margin-right":"10px"},
              src: require('@/assets/images/voice.png')
            }, null, 8, ["src"]),
            _createElementVNode("span", _hoisted_2, _toDisplayString(renderTemplate(item)), 1)
          ], 2))
        }), 128))
      ], 512)
    ]),
    (items.value.length + visibleItems.value.length == 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_el_empty, { description: "活动未开始或暂无中奖记录" })
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})